import React from "react";
import './index.css';
import Modal, {ModalAction, ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import Input from "../../../Components/Control/Input";
import Select from "../../../Components/Control/Select";
import {connect} from "react-redux";
import Resource from "../../../Resource";
import PropTypes from 'prop-types';
import {Tool} from "../../../App";
import Notif from "../../../Components/Notif";
import Configuration from "../../../Server/Configuration";
import MyComponent from '../../../Components/MyComponent';

class ModalHospital extends MyComponent {
    constructor (props) {
        super(props);

        props.refer.current = this;
        console.log('error')

        this.state = {
            title: {
                INSERT: 'افزودن بیمارستان',
                UPDATE: 'ویرایش بیمارستان',
                VIEW: 'اطلاعات بیمارستان'
            },
            provinces: [
                {id: '', text: '...', cities: []},
                ...props.base.provinceCities.map(province => {
                    return {
                        id: province.provinceId, text: province.provinceName, cities: (province.cities || []).map(city => {
                            return {
                                id: city.cityId,
                                text: city.cityName
                            };
                        })
                    };
                })
            ],
            fields: {},
            error: false
        };

        this.ref = {
            modal: React.createRef(),
            insert: React.createRef(),
            update: React.createRef(),
            close: React.createRef(),
            shortName: React.createRef(),
            fullName: React.createRef(),
            provinceId: React.createRef(),
            cityId: React.createRef(),
            address: React.createRef(),
            phoneNumber: React.createRef(),
            mobileNumber: React.createRef(),
            fax: React.createRef()
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    validations = {
        shortName: x => Boolean(x) || 'نام کوتاه وارد نشده است.',
        fullName: x => Boolean(x) || 'نام کامل وارد نشده است.',
        provinceId: x => Boolean(x && x[0]?.id) || 'استان انتخاب نشده است.',
        cityId: x => Boolean(x && x[0]?.id) || 'شهر انتخاب نشده است.'
    };

    shouldComponentUpdate (nextProps, nextState, nextContext) {
        const {state} = this;

        return state.action !== nextState.action ||
            state.error !== nextState.error ||
            state.fields !== nextState.fields;
    }

    componentDidMount () {

    }

    render () {
        const {state} = this;
        const cities = [{id: '', text: '...'}];
        let readOnly = state.action === ModalAction.VIEW;

        cities.push(...((state.fields?.provinceId || [])[0]?.cities || []));

        return <Modal ref={this.ref.modal}
                      name={'ModalHospital'}
                      size={'medium'}
                      title={state.title[state.action]}
                      error={state.error}>
            <ModalContent>
                <div className={'dis-f'}>
                    <Input ref={this.ref.shortName} value={state.fields?.shortName} className={'pad-4 fb-10 fb-2x-20'} label={'نام به اختصار'} readOnly={readOnly} validation={this.validations.shortName} onChange={this.setField.bind(this, 'shortName')}/>
                    <Input ref={this.ref.fullName} value={state.fields?.fullName} className={'pad-4 fb-10 fb-2x-20'} label={'نام کامل'} readOnly={readOnly} validation={this.validations.fullName} onChange={this.setField.bind(this, 'fullName')}/>
                    <Select ref={this.ref.provinceId} value={state.fields?.provinceId} className={'pad-4 fb-10 fb-2x-20'} label={'استان'} readOnly={readOnly} options={state.provinces} validation={this.validations.provinceId} onChange={this.setField.bind(this, 'provinceId')}/>
                    <Select ref={this.ref.cityId} value={state.fields?.cityId} className={'pad-4 fb-10 fb-2x-20'} label={'شهر'} readOnly={readOnly} options={cities} validation={this.validations.cityId} onChange={this.setField.bind(this, 'cityId')}/>
                    <Input ref={this.ref.address} value={state.fields?.address} className={'pad-4 fb-20'} label={'آدرس'} readOnly={readOnly} onChange={this.setField.bind(this, 'address')}/>
                    <Input ref={this.ref.phoneNumber} value={state.fields?.phoneNumber} direction={"ltr"} align={"center"} className={'pad-4 fb-7 fb-2x-20'} label={'شماره تلفن'} readOnly={readOnly} onChange={this.setField.bind(this, 'phoneNumber')}/>
                    <Input ref={this.ref.mobileNumber} value={state.fields?.mobileNumber} direction={"ltr"} align={"center"} className={'pad-4 fb-7 fb-2x-20'} label={'شماره موبایل'} readOnly={readOnly} onChange={this.setField.bind(this, 'mobileNumber')}/>
                    <Input ref={this.ref.fax} value={state.fields?.fax} direction={"ltr"} align={"center"} className={'pad-4 fb-6 fb-2x-20'} label={'شماره فکس'} readOnly={readOnly} onChange={this.setField.bind(this, 'fax')}/>
                </div>
            </ModalContent>
            <ModalControls>
                {state.action === ModalAction.INSERT && <Button refer={this.ref.insert} className={'mar-4'} theme={'blue'} onClick={this.insertClickHandler.bind(this)}>افزودن بیمارستان</Button>}
                {state.action === ModalAction.UPDATE && <Button refer={this.ref.update} className={'mar-4'} theme={'yellow'} onClick={this.updateClickHandler.bind(this)}>ویرایش بیمارستان</Button>}
                <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
            </ModalControls>
        </Modal>;
    }

    insertClickHandler () {
        const {ref, state} = this;

        if (this.validate()) {
            ref.insert.current.loading();
            this.setState({error: null});

            Configuration.addHospital({
                shortName: state.fields?.shortName,
                fullName: state.fields?.fullName,
                provinceId: state.fields?.provinceId[0]?.id,
                cityId: state.fields?.cityId[0]?.id,
                address: state.fields?.address,
                phoneNumber: state.fields?.phoneNumber,
                mobileNumber: state.fields?.mobileNumber,
                fax: state.fields?.fax,
                status: 1
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.INSERT_SUCCESSFUL).show();

                ref.insert.current.loading(false);
                this.close(true);
            }).catch(message => {
                ref.insert.current.loading(false);

                this.setState({error: message});
            });
        }
    }

    updateClickHandler () {
        const {ref, state} = this;

        if (this.validate()) {
            ref.update.current.loading();
            this.setState({error: null});

            Configuration.updateHospital({
                hospitalId: state.fields?.hospitalId,
                shortName: state.fields?.shortName,
                fullName: state.fields?.fullName,
                provinceId: state.fields?.provinceId[0]?.id,
                cityId: state.fields?.cityId[0]?.id,
                address: state.fields?.address,
                phoneNumber: state.fields?.phoneNumber,
                mobileNumber: state.fields?.mobileNumber,
                fax: state.fields?.fax,
                status: state.fields?.status
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.UPDATE_SUCCESSFUL).show();

                ref.update.current.loading(false);
                this.close(true);
            }).catch(message => {
                ref.update.current.loading(false);

                this.setState({error: message});
            });
        }
    }

    open (data, action) {
        console.log(data, action);
        if (action === ModalAction.INSERT) {
            this.setState({
                data,
                action,
                fields: {},
                error: null
            });
        } else if ([ModalAction.VIEW, ModalAction.UPDATE].includes(action)) {
            const cities = (this.state.provinces.find(item => item.id === data.provinceId) || [])?.cities;

            // eslint-disable-next-line eqeqeq
            this.setState({
                data,
                action,
                fields: {
                    hospitalId: data.hospitalId,
                    shortName: data.hospitalShortName,
                    fullName: data.hospitalFullName,
                    provinceId: [{id: data.provinceId, cities}],
                    cityId: [{id: data.cityId}],
                    address: data.hospitalAddress,
                    phoneNumber: data.hospitalPhoneNumber,
                    mobileNumber: data.hospitalMobileNumber,
                    fax: data.hospitalFax,
                    status: data.hospitalStatus === 'فعال' ? 1 : 0
                },
                error: null
            });
        }

        return this.ref.modal.current.open();
    }

    close (success) {
        this.ref.modal.current.close();

        if (success === true)
            this.props.onSuccess();

        this.props.onClose();
    }

    fieldWillUpdate (keys, value, currentFields, nextFields) {
        switch (keys[0]) {
            case 'provinceId':
                delete nextFields?.cityId;
                break;
            default:
        }
    }

    updateCities (provinceId, ret = false) {
        provinceId = provinceId[0]?.id;
        // eslint-disable-next-line eqeqeq
        const province = this.state.provinces.find(item => item.id == provinceId);

        const cities = [
            {id: '', text: '...'},
            ...(province.cities || []).map(item => {
                return {id: item.cityId, text: item.cityName};
            })
        ];

        if (!ret)
            this.setState({cities});
        else
            return cities;
    }

    validate () {
        const validate = Tool.validate(
            this.ref.shortName,
            this.ref.fullName,
            this.ref.provinceId,
            this.ref.cityId);

        if (validate !== true)
            new Notif({message: validate.message, theme: 'error'}).show();

        return validate === true;
    }
}

const mapStateToProps = state => {
    return {
        base: state.base
    };
};

export default connect(mapStateToProps)(ModalHospital);